import { DateTime } from "luxon";

const calculateDuration = (
  departureTime: string,
  arrivalTime: string,
  timezone1: string,
  timezone2: string
): number => {
  const departure = DateTime.fromISO(departureTime, {
    zone: timezone1,
  });
  const arrival = DateTime.fromISO(arrivalTime, {
    zone: timezone2,
  });

  // Convert both to UTC before calculating duration
  const durationMilliseconds = arrival
    .toUTC()
    .diff(departure.toUTC())
    .as("milliseconds");
  const durationMinutes = Math.round(durationMilliseconds / (1000 * 60));
  return durationMinutes;
};

// Memoize formatDuration to prevent recreating on every render
const formatDuration = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h ${mins}m`;
};

export { calculateDuration, formatDuration };
